/* eslint-disable tailwindcss/no-custom-classname -- this is necessary for paywall customization */
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useAppendBodyClasses } from "@circle-react/hooks/useAppendBodyClasses";
import type { CheckoutProps } from "../CheckoutProps";
import { useIsPaywallsCheckoutCustomizationPhase1Enabled } from "./useIsPaywallsCheckoutCustomizationPhase1Enabled";

export const useCheckoutBodyClasses = (props: CheckoutProps) => {
  const isPaywallsCheckoutCustomizationPhase1Enabled =
    useIsPaywallsCheckoutCustomizationPhase1Enabled(props);

  useAppendBodyClasses(
    classNames("paywall-checkout", {
      "!bg-primary": isPaywallsCheckoutCustomizationPhase1Enabled,
      "md:bg-paywall-checkout": !isPaywallsCheckoutCustomizationPhase1Enabled,
    }),
  );
};
